<h2>Execution List</h2>

<ng-template #loadingGeneral>
    <mat-spinner class="center"></mat-spinner>
    <p class="center">Loading...</p>
</ng-template>


<ng-container *ngIf="!loading else loadingGeneral">

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows>

        <ng-container matColumnDef="id">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
            <td *matCellDef="let element" mat-cell> {{element.contractId}} </td>
          </ng-container>

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let element"> {{element.title}} </td>
        </ng-container>

        <ng-container matColumnDef="testbed">
            <th mat-header-cell *matHeaderCellDef> Testbed </th>
            <td mat-cell *matCellDef="let element"> {{element.testbed}} </td>
        </ng-container>

    

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button [routerLink]="['/reserved', 'contracts', element.contractId, 'test-list']"  mat-icon-button matTooltip="Show test list">
                    <mat-icon>input</mat-icon>
                </button>
                <button [routerLink]="['/reserved', 'contracts',element.contractId, 'output-list']" mat-icon-button matTooltip="Show output list">
                    <mat-icon>list</mat-icon>
                </button>
                <button (click)="expandBoxes(element)" mat-icon-button matTooltip="Show Associated Boxes">
                    <mat-icon>grid_view</mat-icon>
                  </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedBoxes">
            <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
                <div fxLayout="row">
                    <h3 class="mb-0" fxFlex>Associated Boxes</h3>
                    <button (click)="expandedBoxes = undefined" mat-button>Close</button>
                </div>
                <table mat-table [dataSource]="element.boxes" class="mat-elevation-z8" multiTemplateDataRows>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let elem"> {{elem.name}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsBoxes"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsBoxes;"></tr>
                </table>
            </td>

        </ng-container>
        
        

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr *matRowDef="let row; columns: ['expandedBoxes']" [fxShow]="expandedBoxes?.contractId === row.contractId" mat-row></tr>

    </table>

</ng-container>